import { render, staticRenderFns } from "./InvestorReceivablePaymentsProgressStatus.vue?vue&type=template&id=2049355b&"
import script from "./InvestorReceivablePaymentsProgressStatus.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsProgressStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports